// extracted by mini-css-extract-plugin
export default {"statistics":"WordStatistics_statistics__cA93M","title":"WordStatistics_title__yuJm2","progress":"WordStatistics_progress__lYyrb","close":"WordStatistics_close__h-tkF"};